import React, { Component } from 'react'
import { Container } from 'semantic-ui-react'

export default class HomePage extends Component {
  render() {
    return <Container>Savor Pos</Container>
  }
}
